import CHARACTER_LIMIT from '../const/characterValidation';
import { t } from '../strings/i18n/i18n';
var validateAmount = function (_a) {
    var inputValue = _a.inputValue, inputType = _a.inputType, transactionAmount = _a.transactionAmount, isEligibleForPartialAmount = _a.isEligibleForPartialAmount;
    var TYPE_NUMBER = 'number';
    if (inputType === TYPE_NUMBER &&
        Number(inputValue) > Number(transactionAmount)) {
        return "".concat(t('formError.invalidAmount'));
    }
    if (!isEligibleForPartialAmount &&
        inputType === TYPE_NUMBER &&
        inputValue.length &&
        Number(inputValue) === 0) {
        return "".concat(t('formError.amountMustBe'));
    }
    if (inputValue.length >= CHARACTER_LIMIT) {
        return "".concat(t('formError.tooManyCharacters'));
    }
    return '';
};
export default validateAmount;
//# sourceMappingURL=validateAmount.js.map